import { useBiLogger } from '../context/BiContext';
import {
  devibePageFinishLoadingSrc196Evid3,
  devibeUserClickSrc196Evid10,
} from '@wix/bi-logger-dev-tools-data/v2';
import {
  getReferralInfoFromCurrentUrl,
  getReferrerFromCurrentUrl,
} from '@wix/dev-center-pages-common/deVibe';

export const useOnboardingPageBi = () => {
  const { logger } = useBiLogger();
  const commonParams = () => {
    return {
      Page_name: 'Onboarding',
      Product_Area: 'Onboarding',
    };
  };
  return {
    reportPageLoadEnd: () => {
      logger.report(
        devibePageFinishLoadingSrc196Evid3({
          ...commonParams(),
          URL: window.location.href,
          Referal_url: getReferrerFromCurrentUrl(),
          Window_height: window.innerHeight,
          Window_width: window.innerWidth,
          Screen_height: screen.height,
          Screen_width: screen.width,
          Referal_info: getReferralInfoFromCurrentUrl(),
        }),
      );
    },
    reportBiClick: ({
      buttonName,
      promptText,
      value,
    }: {
      buttonName: string;
      promptText?: string;
      value?: string;
    }) => {
      logger.report(
        devibeUserClickSrc196Evid10({
          ...commonParams(),
          Button_name: buttonName,
          First_prompt: promptText,
          Value: value,
        }),
      );
    },
  };
};
